import { QuestionDataType } from '../../../../common/interfaces';

const NARROW_TYPES = [QuestionDataType.List, QuestionDataType.Text];
const FULL_WIDTH_TYPES = [QuestionDataType.CheckGroup, QuestionDataType.Grid, QuestionDataType.DisplayText];

/** [ngClass] map that sizes a question's column by its data type; `forceFullWidth` overrides it. */
export const questionColumnClasses = (question: any, forceFullWidth = false) => {
  const dataType = question.configJSON.dataType;
  return {
    'col-md-4': !forceFullWidth && NARROW_TYPES.includes(dataType),
    'col-md-12': forceFullWidth || FULL_WIDTH_TYPES.includes(dataType),
    'hidden': question.hidden
  };
};
